import styled from 'styled-components';

interface IContainer {
  type: 'green' | 'red';
}

export const Container = styled.div`
  background: var(--white-darker);
  color: var(--black-2);
  border-radius: 8px;
  padding: 15px 20px;
  margin-bottom: 20px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  > button {
    background: none;
    height: 30px;
    width: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    > svg {
      color: var(--black-7);
    }
  }
`;

export const Wrapper = styled.div<IContainer>`
  display: flex;
  align-items: center;

  > div:first-child {
    height: 38px;
    width: 38px;
    border-radius: 50%;
    background: ${p =>
      p.type === 'red'
        ? 'var(--danger-transparent)'
        : 'var(--success-transparent)'};
    margin-right: 20px;

    flex: none;

    display: flex;
    align-items: center;
    justify-content: center;
  }

  > div:last-child {
    display: flex;
    flex-direction: column;

    min-width: 0;
  }

  > div strong {
    font-size: 16px;
    width: 100%;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  > div span {
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
